import React from 'react';
import { Link } from 'react-router-dom';
import { useIntl } from 'react-intl';
import { v4 as uuid } from 'uuid';

import { CarouselResponsive, ContainerCustom } from 'components';

import {
  CardPopularWrapper,
  CardPopular,
  CardViewedVillas,
} from '../Main.styles';

const CarouselContainer = ({ itemsList, children }) => {
  const intl = useIntl();

  return (
    <div>
      <CarouselResponsive
        responsive={[
          {
            breakpoint: 770,
            settings: {
              centerMode: true,
              centerPadding: '140px',
              slidesToShow: 1,
              slidesToScroll: 1,
              infinite: true,
              dots: false,
            },
          },
          {
            breakpoint: 770,
            settings: {
              centerMode: true,
              centerPadding: '100px',
              slidesToShow: 1,
              slidesToScroll: 1,
              infinite: true,
              dots: false,
            },
          },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              initialSlide: 1,
            },
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
            },
          },
        ]}
        padding="25px 0"
      >
        {itemsList.map((hotel) => (
          <div>
            {/* <Link to={`${hotel.urls.filterUrl}`} target="_blank"> */}
            <CardPopularWrapper>
              <div>
                <CardPopular>
                  <CardViewedVillas>
                    {React.cloneElement(children, {
                      isMobile: true,
                      key: uuid(),
                      hotel: hotel,
                    })}

                    {/* <CardViewed isMobile={true} key={uuid()} hotel={hotel} /> */}
                  </CardViewedVillas>
                </CardPopular>
              </div>
            </CardPopularWrapper>
            {/* </Link> */}
          </div>
        ))}
      </CarouselResponsive>
    </div>
  );
};

const ScrollContainer = ({ itemsList, children }) => {
  return (
    <ContainerCustom
      paddingTablet="0"
      display="flex"
      wrap="no-wrap"
      overflowX="scroll"
    >
      {itemsList.map((hotel, i) => (
        <CardPopular
          shadow="0px 10px 50px rgba(0, 82, 180, 0.1)"
          margin={'0 19px 47px 0'}
          widthLaptop="41vw"
          widthM="70vw"
          minWidth="70vw"
        >
          <CardViewedVillas>
            {React.cloneElement(children, {
              isMobile: true,
              key: uuid(),
              hotel: hotel,
            })}
          </CardViewedVillas>
        </CardPopular>
      ))}
    </ContainerCustom>
  );
};

export { CarouselContainer, ScrollContainer };
